import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "searcher" }
const _hoisted_2 = {
  key: 1,
  class: "dropdown-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isVisibleSearch)
      ? (_openBlock(), _createBlock(_component_q_form, {
          key: 0,
          onSubmit: _ctx.searchEmit,
          class: "searcher-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_input, {
              outlined: "",
              "bottom-slots": "",
              modelValue: _ctx.searcherComputed,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searcherComputed) = $event)),
              label: _ctx.labelSearcher,
              dense: true
            }, {
              append: _withCtx(() => [
                (_ctx.searcher !== '')
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      name: "close",
                      onClick: _ctx.resetSearcher,
                      class: "cursor-pointer"
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_icon, { name: "search" })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.labelTooltip), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "label"])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.isVisibleDropdown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_btn_dropdown, {
            color: "blue-grey-3",
            label: "Activo / Inactivo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_list, null, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, { tag: "label" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, {
                        side: "",
                        top: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_checkbox, {
                            modelValue: _ctx.activeComputed,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeComputed) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Activos")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, { tag: "label" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, {
                        side: "",
                        top: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_checkbox, {
                            modelValue: _ctx.inactiveComputed,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inactiveComputed) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Inactivos")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}